<template>
	<div class="fixwidth">
		<div class="nav">课程设计</div>
		<div class="design-box">
			<div class="catalog-box">
				<div class="catalog" v-for="(c,index) in catalog" :key="c.id">
					<!--章节菜单开始-->
					<div class="clearfix overflow_hide title">
						<div class="fl catalog-name">
							<span>
								<i @click="expandCatalog(c)"
								   style="cursor: pointer"
								   :class="c.expansion?'el-icon-arrow-down':'el-icon-arrow-right'"/>
							</span>
							<span>{{index+1}}.</span>
							<span v-if="!c.edit">{{c.name}}</span>
							<span v-else>
								<el-input ref="input" v-model="c.name" style="width:200px;display: inline-block"/>
								<el-button @click="confirmEditCatalog(c)">确认</el-button>
								<el-button @click="c.edit=false">取消</el-button>
							</span>
						</div>
						<div class="fr btn-group">
							<span @click="openUploadBox(c)">
								<img src="../../../static/img/course/upload.png" alt="upload">
							</span>
							<span>|</span>
							<span @click="editCatalog(c)">
								<img src="../../../static/img/course/edit.png" alt="edit">
							</span>
							<span>|</span>
							<span @click="deleteCatalog(c)">
								<img src="../../../static/img/course/delete.png" alt="delete">
							</span>
						</div>
					</div>
					<!--章节菜单结束-->
					<!--循环小节目录-->
					<div class="section-box" v-if="c.expansion">
						<div v-if="c.resourceList!==null">
							<div v-for="rc in c.resourceList" class="resource-list overflow_hide" :key="rc.id">
								<div class="fl">
									<span class="type-sign">
										{{rc.type|resourceType}}
									</span>
									<span v-if="!rc.edit">{{rc.name}}</span>
									<span v-else style="width:400px;">
										<el-input ref="input" v-model="rc.name" style="width:200px;display: inline-block"/>
										<el-button @click="confirmEdit(rc)">确认</el-button>
										<el-button @click="rc.edit=false">取消</el-button>
									</span>
								</div>
								<div class="fr">
									<div class="btn-group">
										<span @click="editResource(rc)">
											<img src="../../../static/img/course/edit.png" alt="edit">
										</span>
										<span>|</span>
										<span @click="deleteResource(rc,c)">
											<img src="../../../static/img/course/delete.png" alt="delete">
										</span>
									</div>
								</div>
							</div>
						</div>
						<div class="catalog overflow_hide"
							 v-for="mc in c.childList"
							 :key="mc.id">
							<div class="fl">
								<!--控制资源展开-->
								<span><i @click="expandResource(mc)"
										 style="transition: 0.2s;cursor: pointer"
										 :class="mc.resourceExpansion?'el-icon-arrow-down':'el-icon-arrow-right'"/></span>
								<!--<span>{{index+1}}.{{mc.name}}</span>-->
								<span v-if="!mc.edit">{{mc.name}}</span>
								<span v-else>
								<el-input ref="input" v-model="mc.name" style="width:200px;display: inline-block"/>
								<el-button @click="confirmEditCatalog(mc)">确认</el-button>
								<el-button @click="mc.edit=false">取消</el-button>
							</span>
							</div>
							<div class="fr">
								<div class="btn-group">
									<span @click="openUploadBox(mc)">
										<img src="../../../static/img/course/upload.png" alt="upload">
									</span>
									<span>|</span>
									<span @click="editCatalog(mc)">
										<img src="../../../static/img/course/edit.png" alt="edit">
									</span>
									<span>|</span>
									<span @click="deleteCatalog(mc)">
										<img src="../../../static/img/course/delete.png" alt="delete">
									</span>
								</div>
							</div>

							<!--开始循环每一节的资源-->
							<div v-if="mc.resourceExpansion">
								<div v-for="rc in mc.resourceList"
									 class="resource-list clearfix overflow_hide"
									 :key="rc.id">
									<div class="fl">
										<span class="type-sign">{{rc.type|resourceType}}</span>
										<span v-if="!rc.edit">{{rc.name}}</span>
										<span v-else style="width:400px;">
											<el-input ref="input" v-model="rc.name" style="width:200px;display: inline-block"></el-input>
											<el-button @click="confirmEdit(rc)">确认</el-button>
											<el-button @click="rc.edit=false">取消</el-button>
										</span>
									</div>
									<div class="fr">
										<div class="btn-group">
											<span @click="editResource(rc)">
												<img src="../../../static/img/course/edit.png" alt="edit">
											</span>
											<span>|</span>
											<span @click="deleteResource(rc,mc)">
												<img src="../../../static/img/course/delete.png" alt="delete">
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="catalog add-box" v-if="c.addSectionFlag">
							<span>{{c.length}}</span>
							<el-input style="width:200px" v-model="sectionName"></el-input>
							<el-button @click="saveSection(c)">保存</el-button>
							<el-button @click="c.addSectionFlag=false">取消</el-button>
						</div>
						<div class="catalog-btn" @click="addSection(c)">添加章节</div>
					</div>
				</div>
				<!--循环小节目录结束-->
				<!--增加大章节-->
				<div class="catalog add-box" v-if="catalogFlag">
					<span>{{catalog.length+1}}.</span>
					<el-input style="width:200px" v-model="name"></el-input>
					<el-button @click="saveCatalog">保存</el-button>
					<el-button @click="catalogFlag=false">取消</el-button>
				</div>
			</div>
			<div class="catalog-btn" @click="addCatalog">添加章节</div>
		</div>

		<!--@close="cancelDialog"-->
		<el-dialog
				:close-on-click-modal="false"
				title="上传资源"
				width="800px"
				class="resource-dialog"
				:visible.sync="uploadVisible">
			<div class="overflow_hide">
				<div class="fl notice">
					<div>
						<h4>1、根据国家《出版管理条例》《网络出版服务管理规定》及教育部《职业教育专业教学资源库建设工作手册》等相关规定，上传的资源必须符合以下要求：</h4>
						<p>1. 没有法律、法规禁止出版的内容，没有政治性、道德性问题和科学性错误，不泄露国家秘密。
						<p>2. 不含有侵犯他人著作权、肖像权、名誉权等权益的内容，资源具有原创性，引用需指明作者姓名、作品名称，使用他人作品应取得许可。
						<p>3. 采用法定计量单位，名词、术语、符号等符合国家统一规定，尚无统一规定的，可采用习惯用法并保持一致。
						<p>4. 地图具有严肃的政治性、严密的科学性和严格的法定性，使用的地图应根据《地图管理条例》的要求已送相关部门审核并标注审图号。
						<h4>2、为确保上传成功，我们建议您每次最多上传不超过3份文件</h4>
						<h4>3、本系统目前支持以下的系统格式文档：</h4>
						<p>office文档： doc  docx  xls  xlsx  wps  wpt   pdf   ppt  pptx</p>
						<p>音视频： flv  swf  asf  avi  mpg  3gp  mp3  mp4  wav  rm  rmvb  wmv</p>
						<p>图片： jpg  jpeg  png  tif  tiff  bmp  gif</p>
					</div>
				</div>
				<div class="fr upload">
					<div v-for="(f,index) in fileList" :key="index">
						<el-input style="width:120px;" v-model="f.name"/>
						<el-switch
								v-model="f.whether"
								active-text="收费"
								inactive-text="免费">
						</el-switch>
						<i class="el-icon-error" @click="deleteFile(f,index)"
						   style="color:red;margin-left:10px;font-size:16px;cursor:pointer;"/>
						<!--<div>
							<span v-if="!progressList[index].pause" @click="progressList[index].pause=true">暂停</span>
							<span v-else @click="begin(f,index)">开始</span>
						</div>-->
						<el-progress
								:text-inside="true"
								:stroke-width="20"
								:percentage="Math.ceil(progressList[index].finished/progressList[index].total*100)"
								status="success"/>
					</div>
					<el-upload
							ref="upload"
							class="upload-demo fr"
							style="margin-left:20px"
							action=""
							:file-list="fileList"
							:on-change="handleChange"
							:auto-upload=false
							:show-file-list=false>
						<el-button style="float: none !important;" size="small" type="primary">选择文件</el-button>
					</el-upload>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="uploadVisible = false">取 消</el-button>
				<el-button type="primary" @click="formSubmit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import classifyBySuffix from '../../assets/js/suffix';
	import plus from '../../assets/js/plus';
	import getFileMd5 from '../../assets/js/getFileMd5';
	//import SparkMD5 from 'spark-md5'
	export default {
		name: "CourseDetail",
		data() {
			return {
				catalog:[],
				total:0,
				catalogFlag:false,
				name:"",
				sectionName:"",
				uploadVisible:false,         //上传对话框
				fileList:[],                 //上传文件列表
				catalogId:"",                //用于记录上传文件时候的目录id
				catalogObject:{},
				editResourceId:"",            //记录修改资源id
				editCatalogId:"",              //记录修改的目录id
				pause:false,
				pauseData:{},
				uploadChunks:0,              //已经传的分片
				fileIndex:0,                  //区分多文件上传的序号
				progressList:[],
				click:false                   //区分是否已经点击上传
			}
		},
		created() {
			this.getCatalogList();
		},
		filters:{
			resourceType(data){
				switch (data) {
					case "document":
						return "文档";
					case "picture":
						return "图片";
					case "video":
						return "视频";
				}
			}
		},
		computed:{
			progress(){
				return this.$store.getters.getProgress;
			}
		},
		methods:{
			getCatalogList(){
				this.$json("/course/detail/"+this.$route.params.courseId+"/"+this.$store.getters.getToken.id,"GET",{}).then(res=>{
					this.catalog = res.data.catalogList===null?[]:res.data.catalogList;
					this.total = this.catalog.length;
				})
			},
			//展开每个章节
			expandCatalog(c){
				this.$nextTick(()=>{
					this.$set(c,"expansion",!c.expansion);
				});
				this.$json("/resource/catalog/"+c.id,"GET",{}).then(res=>{
					c.resourceList = res.data;
				});
			},
			//展开资源列表
			expandResource(mc){
				this.$nextTick(()=>{
					this.$set(mc,"resourceExpansion",!mc.resourceExpansion);
				});
				this.$json("/resource/catalog/"+mc.id,"GET",{}).then(res=>{
					mc.resourceList = res.data;
				});
			},
			//添加章节
			addCatalog(){
				this.name = "";
				if(!this.catalogFlag){
					this.catalogFlag = true;
				}
				else return false;
			},
			//增加大章节
			saveCatalog(){
				let data ={
					courseId:this.$route.params.courseId,
					level:1,
					sequenceId:this.catalog.length>0?parseInt(this.catalog[this.catalog.length-1].sequenceId)+1:1,
					name:this.name
				};
				this.$json("/course/catalog","POST",data).then(()=>{
					this.getCatalogList();
					this.name = "";
				})
			},
			//删除大章节
			deleteCatalog(r){
				this.$confirm('是否删除该目录?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$json("/course/catalog/"+r.id,"DELETE",{}).then(()=>{
						this.getCatalogList();
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消操作'
					});
				});
			},
			//增加小章节
			addSection(c){
				//addSectionFlag
				this.$nextTick(()=>{
					this.$set(c,"addSectionFlag",true);
				})
			},
			//保存小节
			saveSection(c){
				let data ={
					courseId:this.$route.params.courseId,
					level:2,
					sequenceId:c.childList.length===0?1:parseInt(c.childList[c.childList.length-1].sequenceId)+1,
					name:this.sectionName,
					parentId:c.id
				};
				this.$json("/course/catalog","POST",data).then(()=>{
					this.getCatalogList();
					this.sectionName = "";
				})
			},
			openUploadBox(mc){
				this.uploadVisible = true;
				this.catalogId = mc.id;
				this.catalogObject = mc;
				this.fileList = [];
				this.progressList=[];
				this.$store.dispatch('setUploadProgress',0);
			},
			//上传文件
			handleChange(file,fileList){
				this.fileList = fileList;
				this.progressList.push({total:1,finished:0,pause:false})
			},
			//上传列表删除文件
			deleteFile(f,index){
				this.fileList.splice(index,1);
			},
			formSubmit(){
				//防止重复点击
				if(!this.click){
					if(this.fileList.length===0){
						this.$message.warning("请选择上传文件")
					}else{
						this.click = true;
						for(let i=0;i<this.fileList.length;i++){
							this.uploadFile(i);
						}
					}
				}else{
					this.$message("正在上传请勿重复点击");
				}
			},
			uploadFile(index){
				if(index+1<=this.fileList.length){
					let suffixIndex = this.fileList[index].raw.name.lastIndexOf(".");
					getFileMd5.getMd5(this.fileList[index].raw).then(res=> {
						let postData = {guid: res.md5, suffix:this.fileList[index].raw.name.substring(suffixIndex)};
						this.$json("/file/guid/check","POST",postData).then(res=>{
							if(res.data.status){
								if(res.data.maxSize!==undefined){
									this.progressList[index].finished = res.data.maxSize;
									this.uploadSlice(this.fileList[index].raw, res.data.maxSize, postData.guid, this.fileList[index].name,index);
								}
								else{
									let arr= [{
										name:this.fileList[index].name,
										type:classifyBySuffix(this.fileList[index].raw.name.substring(suffixIndex+1)),
										catalogId:this.catalogId,
										url:res.data.path,whether:this.fileList[index].whether===undefined||!this.fileList[index].whether?1:0}];
									this.$json("/resource","POST",arr).then(res=>{
										this.progressList[index].total = 1;
										this.progressList[index].finish = 1;
										let flag = true;
										for(let i in this.progressList){
											if(this.progressList[i].total!==this.progressList[i].finished){
												flag = false;
											}
										}
										if(flag){
											this.$message.success("上传成功");
											this.uploadVisible=false;
											this.click = false;
											this.getCatalogList();
										}

									})
								}

							}else{
								this.uploadSlice(this.fileList[index].raw, 0, postData.guid, this.fileList[index].raw.name,index);
							}
						},err=>{
							console.log(err);
						})
						/*this.$json("/file/chunk/check","POST",postData).then(res=>{
                            if(res.data){
                                this.$message.error("该文件已经上传")
                            }else{
                                this.uploadSlice(this.fileList[index].raw, 0, postData.guid, this.fileList[index].name,index);
                            }
                        });*/
					});
				}
			},
			uploadSlice(file,index,guid,fileName,fileListIndex){
				//分片文件  分片数  md5
				let config = {
					headers: { 'Content-Type': 'multipart/form-data' },
				};
				getFileMd5.getSliceFile(file,index).then(res=>{
					let uploadChunk = new FormData();
					uploadChunk.append("file",res.file);
					uploadChunk.append("guid",guid);
					uploadChunk.append("chunk",index);
					uploadChunk.append("size",res.size);
					uploadChunk.append("total",res.total);
					this.progressList[fileListIndex].total = res.total;
					if(!res.ifLast){
						//没有暂停
						if(!this.pause){
							this.$upload("/file/chunk/upload",uploadChunk,config).then(response=>{
								if(response.data){
									this.uploadSlice(file,index+1,guid,fileName,fileListIndex);
									this.progressList[fileListIndex].finished++;
								}
							})
						}
						else{
							this.progressList[fileListIndex].chunk = index;
						}
						/*else{
                            this.pauseData={
                                guid:guid,
                                chunk:index
                            }
                        }*/

					}
					else{
						let iIndex = this.fileList[fileListIndex].raw.name.lastIndexOf(".");
						this.$json("/file/chunk/merge","POST",{guid:guid,name:fileName,suffix:this.fileList[fileListIndex].raw.name.substring(iIndex),chunk:index+1,size:res.size,total:res.total}).then(res=>{
							let suffixIndex = this.fileList[fileListIndex].raw.name.lastIndexOf(".");
							let arr= [{
								name:this.fileList[fileListIndex].name,
								type:classifyBySuffix(this.fileList[fileListIndex].raw.name.substring(suffixIndex+1)),
								catalogId:this.catalogId,
								url:res.data,whether:this.fileList[fileListIndex].whether===undefined||!this.fileList[fileListIndex].whether?"1":"0"}];
							this.$json("/resource","POST",arr).then(res=>{
								console.log(res);
							});
							let flag = true;
							for(let i in this.progressList){
								if(this.progressList[i].total!==this.progressList[i].finished){
									flag = false;
								}
							}
							if(flag){
								this.$message.success("上传成功");
								this.uploadVisible=false;
								this.click = false;
								this.getCatalogList();
							}
							//this.fileIndex++;
							//this.uploadFile(this.fileIndex);
						})
					}
				})
			},
			begin(f,index){
				//this.progressList[index].chunk =
			},
			//删除资源
			deleteResource(rc,c){
				this.$confirm('是否删除该资源?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$json("/resource/"+rc.id,"DELETE",{}).then(()=>{
						this.$message("删除成功");
						this.fresh(c,rc.catalogId);
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消操作'
					});
				});
			},
			//修改资源信息
			editResource(rc){
				this.$nextTick(function () {
					this.$set(rc, 'edit', true);
				});
				this.editResourceId = rc.id;
			},
			confirmEdit(rc){
				this.$json("/resource","PUT",rc).then(()=>{
					this.$nextTick(function () {
						this.$set(rc, 'edit', false);
					});
					this.getCatalogList();
				})
			},

			//局部刷新
			fresh(catalog,catalogId){
				this.$json("/resource/catalog/"+catalogId,"GET",{}).then(res=>{
					catalog.resourceList = res.data;
				});
			},
			editCatalog(c){
				this.$nextTick(function () {
					this.$set(c, 'edit', true);
				});
				this.editCatalogId = c.id;
			},
			confirmEditCatalog(c){
				this.$json("/course/catalog/selective","PUT",{id:this.editCatalogId,name:c.name}).then(()=>{
					this.$nextTick(function () {
						this.$set(c, 'edit', false);
					});
				});
			}
		}
	}
</script>

<style scoped lang="less">

	.add-box{
		text-align: left;
	}

	.left-40{
		width:calc(100% - 40px) !important;
		margin-left:40px;
	}

	.catalog-btn{
		height:40px;
		line-height: 40px;
		box-sizing: border-box;
		border:1px solid #ccc;
		text-align: center;
		width:100%;
		cursor: pointer;
	}

	.nav{
		height:40px;
		line-height: 40px;
		background-color: #fff;
		text-align: left;
	}

	.design-box{
		.catalog-box{
			.catalog{
				//height:40px;
				line-height: 40px;
				background-color: #eee;
				text-align: left;
				margin: 10px 0;
				.title{
					font-size:16px;
					font-weight: bold;
				}
			}
		}
		//小节
		.section-box{
			padding-left:40px;
		}
	}




	//上传文件
	.resource-dialog{
		.upload{
			width:40%;
			text-align: center;
		}
		.notice{
			width:60%;
			height:100%;
			text-align: left;
			box-sizing: border-box;
			border-right:1px solid #dddddd;
			p{
				text-indent: 10px;
			}
			h4,p{
				line-height: 20px;
			}
		}
	}

	//资源列表
	.resource-list{
		padding-left:20px;
		font-size:14px;
		.type-sign{
			display: inline-block;
			width: 40px;
			height: 25px;
			line-height: 25px;
			font-size: 12px;
			box-sizing: border-box;
			border:1px solid #ddd;
			text-align: center;
		}
	}

	.btn-group{
		span{
			display: inline-block;
			margin:0 5px;
			img{
				cursor: pointer;
				margin-top:10px;
				width:16px;
				height:16px;
			}
		}
		span:last-child img{
			width:13px !important;
		}
	}


</style>
